<div class="key-value-tag-editor">
  <div class="tag-row" *ngFor="let row of rows; let i = index; trackBy: trackByIndex">
    <div class="key-field">
      <input
        class="key-input"
        [class.invalid]="rowErrors[i]?.keyRequired || rowErrors[i]?.keyDuplicate"
        type="text"
        placeholder="Key"
        [value]="row.key"
        [disabled]="disabled"
        (input)="onKeyChange(i, $any($event.target).value)"
        (blur)="onKeyBlur(i)"
      />
      <div class="error-message" *ngIf="rowErrors[i]?.keyRequired">Required</div>
      <div class="error-message" *ngIf="rowErrors[i]?.keyDuplicate">Key is already used</div>
    </div>

    <div class="value-field">
      <div class="pill-input-container" [class.disabled]="disabled" [class.invalid]="rowErrors[i]?.valuesRequired">
        <rad-chip
          *ngFor="let val of row.values; let vi = index"
          class="rad-theme--light value-pill"
          [attr.label]="val"
          [attr.dismissible]="!disabled"
          (chipRemoved)="removePill(i, vi)">
        </rad-chip>
        <input
          class="pill-text-input"
          type="text"
          placeholder="Enter value(s)..."
          [disabled]="disabled"
          [value]="inputTexts[i]"
          (input)="inputTexts[i] = $any($event.target).value"
          (keydown)="onValueInputKeydown($event, i)"
          (blur)="onValueBlur(i)"
        />
      </div>
      <div class="error-message" *ngIf="rowErrors[i]?.valuesRequired">Required</div>
    </div>

    <button
      class="remove-row-btn"
      type="button"
      [disabled]="disabled"
      (click)="removeRow(i)"
      title="Remove tag row">
      &times;
    </button>
  </div>

  <rad-button
    class="rad-theme--light add-tag-btn"
    [attr.tertiary]="true"
    [attr.disabled]="disabled || null"
    (click)="addRow()">
    + Add Tag
  </rad-button>
</div>
